import { TESTIMONIALS, SHIPPING_PROTECTION_TESTIMONIALS } from './testimonials'

export { TESTIMONIALS, SHIPPING_PROTECTION_TESTIMONIALS }
